import * as axios from "axios";
import LocationModel from "models/Location";

class Google  {
	google_key = "";
	
  constructor() {
    this.google_key = process.env.REACT_APP_GOOGLE_KEY;

  }	
	getSearchLocation = async (location) => {
		const geocoderQuery = encodeURIComponent(`${location}`.replace(/ /g, '+'));
		
		var config = {
			method: 'get',
			url: "https://maps.googleapis.com/maps/api/geocode/json?key="+this.google_key+"&address="+geocoderQuery,
			secure: false //important
		};		
		
		var promise = await axios(config)
.then(function (response) {
	let locationModel;
	if( response.data.status == "OK" && Array.isArray(response.data.results) && response.data.results.length > 0 ) {
		let locationData = response.data.results[0];
		locationModel = new LocationModel();
		locationModel.place_id = locationData.place_id;
		//locationModel.address = locationData.address_components;
		for(let i in locationData.address_components) {
			let addressComponent = locationData.address_components[i];
			let type = addressComponent.types[0];
			switch(type) {
				case 'route':
					locationModel.address = addressComponent.long_name;
					break;				
				case 'locality':					
				case 'administrative_area_level_2':
					if(!locationModel.place_name) {
						locationModel.place_name = addressComponent.long_name;
					}
					break;				
				case 'administrative_area_level_1':
					locationModel.region = addressComponent.long_name;
					locationModel.region_short = addressComponent.short_name;
					break;				
				case 'country':
					locationModel.country = addressComponent.long_name;
					locationModel.country_short = addressComponent.short_name;
					break;				
				case 'postal_code':
					locationModel.zipcode = addressComponent.long_name;
					break;				
			}
		
		
		}
		locationModel.lat = locationData.geometry.location.lat;
		locationModel.lng = locationData.geometry.location.lng;
	
	}
	return locationModel;
	//return response.data;
})
.catch(function (error) {
	console.log(error);
	return error;
});
return promise;
		
	};
	
}
export default new Google();
